import { useContentResource } from "@ctv/core";
import { DocumentFieldValue, Text, Token } from "@ctv/shared-core/src";

import DocumentIcon from "@traveloka/icon-kit-web/react/IcSystemDocument";

import { StyleSheet, View } from "react-native";

import ReviewRow from "./ReviewRow";

type DocumentProps = {
  document: DocumentFieldValue;
  label?: string;
  handleViewDocument(): void;
};

export function DocumentRow(props: DocumentProps) {
  const { document, label, handleViewDocument } = props;

  const { CorporateRegistration: cr } = useContentResource();

  return (
    <ReviewRow
      label={label}
      value={
        <View style={styles.documentContent}>
          <View style={styles.row}>
            <DocumentIcon height={24} width={24} />
            <Text
              variant="ui-baseline"
              ink="black-secondary"
              style={styles.documentValue}
            >
              {document.file.name}
            </Text>
          </View>
          <Text
            style={styles.viewButton}
            variant="title-2"
            ink="interactive"
            onPress={handleViewDocument}
          >
            {cr.reviewViewButton}
          </Text>
        </View>
      }
    />
  );
}

const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    alignItems: "center",
    flex: 1,
  },
  documentContent: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    wordBreak: "break-all",
  },
  documentValue: {
    marginStart: Token.spacing.xs,
  },
  viewButton: {
    marginLeft: Token.spacing.xs,
  },
});
